import React from "react";
import PropTypes from "prop-types";
import { Td } from "./Td";
import { Icon, IconLabel } from "../Icons";

const propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string
};
const defaultProps = {
  label: ""
};

export const TdIcon = props => {
  const { label } = props;
  return (
    <Td {...props}>
      {label.length > 0 ? (
        <IconLabel label={label}>{props.children}</IconLabel>
      ) : (
        <Icon>{props.children}</Icon>
      )}
    </Td>
  );
};

TdIcon.propTypes = propTypes;
TdIcon.defaultProps = defaultProps;

export default TdIcon;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Td/TdIcon.js